import script from "./BaseErrorMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseErrorMessage.vue?vue&type=script&setup=true&lang=js"

import "./BaseErrorMessage.vue?vue&type=style&index=0&id=01933240&lang=scss&scoped=true"

import exportComponent from "C:\\Humanfrog\\projects\\btc-lcz\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01933240"]])

export default __exports__